import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core'
import { BasicAuthService } from '../../../../services/basic-auth.service'
import {
  DataCardGroupType,
  DataCardService,
  DataCardType,
} from '../../../../services/data-card.service'
import { HttpErrorResponse } from '@angular/common/http'
import { HttpResponseHandlerService } from '../../../../services/http-response-handler.service'
import {
  IDataCardFE,
  IDataCardBFGI,
  IDataCardBPI,
  IDataCardFGD,
  IDataCardPT,
  IDataCardSDL,
} from '../../../../models/data-card.model'
import { HelperService } from '../../../../services/helper.service'

@Component({
    selector: 'app-main-object-data-card-template',
    templateUrl: './main-object-data-card-template.component.html',
    styleUrls: ['./main-object-data-card-template.component.scss'],
    standalone: false
})
export class MainObjectDataCardTemplateComponent implements OnInit {
  @Input() mo: string

  private _moData:
    | IDataCardFE
    | IDataCardPT
    | IDataCardBPI
    | IDataCardBFGI
    | IDataCardFGD
    | IDataCardSDL
  private _deviationURLData: any
  private _moType: DataCardType | null = null
  private _isLoading: { mo: boolean; url: boolean; typical: boolean } = {
    mo: false,
    url: false,
    typical: false,
  }
  private _mainFormChangeEvent: EventEmitter<any> = new EventEmitter()
  private _devURLChangeEvent: EventEmitter<any> = new EventEmitter()

  public get mainFormChangeEvent(): EventEmitter<any> {
    return this._mainFormChangeEvent
  }

  public get devURLChangeEvent(): EventEmitter<any> {
    return this._devURLChangeEvent
  }

  constructor(
    private cdf: ChangeDetectorRef,
    private service: DataCardService,
    private authService: BasicAuthService,
    private handlerResponseService: HttpResponseHandlerService,
  ) {}

  public get isLoading(): { mo: boolean; url: boolean; typical: boolean } {
    return this._isLoading
  }

  public get moData(): any {
    return this._moData
  }

  public get moDataFE(): IDataCardFE {
    return this._moData as IDataCardFE
  }

  public get moDataPT(): IDataCardPT {
    return this._moData as IDataCardPT
  }

  public get moDataBPI(): IDataCardBPI {
    return this._moData as IDataCardBPI
  }

  public get moDataFGD(): IDataCardFGD {
    return this._moData as IDataCardFGD
  }

  public get moDataBFGI(): IDataCardBFGI {
    return this._moData as IDataCardBFGI
  }

  public get moDataSDL(): IDataCardSDL {
    return this._moData as IDataCardSDL
  }

  public get moType(): DataCardType {
    return this._moType
  }

  public get deviationURLData(): any {
    return this._deviationURLData
  }

  public canSaveDataCard(): boolean {
    return this.authService.canSaveDataCard()
  }

  public hasCMMSPackage(): boolean {
    return this.authService.hasCMMSPackage()
  }

  public hasRCAFPackage(): boolean {
    return this.authService.hasRCAFPackage()
  }

  public getTravelTimeMonitoringURLParams(mainObject: string) {
    return this.service.getTravelTimeMonitoringURLParams(mainObject)
  }

  public displayMainForm(): boolean {
    return (
      !this._isLoading.mo &&
      !HelperService.isNullOrUndefined(this._moData) &&
      ['VLV', 'BRK', 'FD_FE_MOT_NFS'].indexOf(this._moType) !== -1
    )
  }

  public displayDeviationURLForm(): boolean {
    return (
      this.authService.hasExtendedAdminAccess() &&
      !this._isLoading.url &&
      this._deviationURLData &&
      !HelperService.isNullOrUndefined(this._moData) &&
      this._moType !== 'SDL'
    )
  }

  private getDataCardByType(mo: string, type: DataCardGroupType): void {
    this._isLoading.mo = true
    this.service.getDataCardByGroupType(mo, type).subscribe({
      next: (resource: any): void => {
        this._moData = resource
        this._isLoading.mo = false
      },
      error: (error: HttpErrorResponse): void => {
        this.handlerResponseService.notifyError(error)
        this._isLoading.mo = false
      },
      complete: (): void => {
        this.cdf.detectChanges()
      },
    })
  }

  private getDeviationUrl(): void {
    if (!this.authService.hasExtendedAdminAccess()) {
      return
    }
    this._isLoading.url = true
    this.service.getDeviationUrl(this.mo).subscribe({
      next: (resource: any): void => {
        this._deviationURLData = resource
        this._isLoading.url = false
      },
      error: (error: HttpErrorResponse): void => {
        if (error.status !== 404) {
          this.handlerResponseService.notifyError(error)
          this._isLoading.url = false
        }
      },
    })
  }

  private getCardDataByTypical(): void {
    this._isLoading.mo = true
    this.service.getTypical(this.mo).subscribe({
      next: (data: { typical: string | null; mo: string | null }): void => {
        this._moType = this.service.getDataCardTypeByTypical(data.typical)
        const groupType: DataCardGroupType = this.service.getDataCardGroupTypeByType(this._moType)

        if (groupType === null) {
          this._moData = null
          this._isLoading.mo = false
          return
        }

        this.getDataCardByType(data.mo !== null ? data.mo : this.mo, groupType)
      },
      error: (error: HttpErrorResponse): void => {
        this.handlerResponseService.notifyError(error)
        this._isLoading.mo = false
      },
    })
  }

  public onNotifyDataCardMainForm(event: any): void {
    this._mainFormChangeEvent.next(event)
  }

  public onNotifyDataCardDevUrl(event: any): void {
    this._devURLChangeEvent.next(event)
  }

  public onOpenNewMO(event: string): void {
    this.refreshMO(event)
  }

  private refreshMO(mo: string): void {
    this.mo = mo
    this.getCardDataByTypical()
    this.getDeviationUrl()
  }

  public ngOnInit(): void {
    if (!HelperService.isNullOrUndefined(this.mo)) {
      this.getCardDataByTypical()
      this.getDeviationUrl()
    }
  }
}
